import { Box, useMediaQuery } from "@mui/material"
import { BackdropComponent, BreadCrumb } from "../../../components";
import VendorInfo from "./VendorInfo";
import VendorFeatures from "./VendorFeatures";
import VendorImageList from "./VendorImageList";
import VendorReviews from "./VendorReview";
import ssoFrame from "../../../assets/images/other/sso_frame.png";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getQueryData, getVendorDetailsByNameURL, withCredentials } from "../../../services";
import { useEffect, useState } from "react";
import VendorTempData from "../../../assets/data/vendorList";
import { theme } from "../../../utils";

export const VendorDetails = () => {
    const [searchParams] = useSearchParams();
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const routeTitle: any = searchParams.get("routePath");
    const vendorName: any = searchParams.get("vendor");
    const vendorIndex: any = searchParams.get("index");

    const tempData:any = vendorIndex ? VendorTempData?.data[vendorIndex] : {}

    // Set the breadcrumb path for vendorDetails
    const crumbPath = [
        { name: "Home", url: "/home" },
        { name: "AI Tools", url: "/ai-tools" },
        { name: routeTitle, url: "/vendor-details" }
    ]

    const [vendorDetails, setVendorDetails] = useState<any>({})

    const { data: vendorDetailsData, isLoading: isVendorDetailsLoading } = useQuery("vendorDetailsData", async () =>
        getQueryData(getVendorDetailsByNameURL(vendorName), withCredentials()),
        { enabled: vendorName !== "" }
    );

    useEffect(() => {
        if (vendorDetailsData?.data) {
            setVendorDetails(vendorDetailsData?.data)
        }
        window.scrollTo(0, 0)
    }, [vendorDetailsData])

    return (
        <Box sx={{ py: "30px", pl: "20px", px: isMobile ? "31px":"181px", mt: "40px" }} textAlign={"left"}>
            <BreadCrumb breadCrumbPath={crumbPath} />
            <Box sx={{pl:'27px'}}>
                <VendorInfo infoData={vendorDetails} demoUrl={tempData?.demoVideoUrl}/>
                <VendorFeatures featureData={vendorDetails} />
                <VendorImageList imageList={tempData?.imageList} />
                <VendorReviews reviewData={tempData?.reviews} vendorName={vendorName}/>
            </Box>
            {vendorDetails?.isSSOEnabled ?
                <img src={ssoFrame} style={{ width: "50px", height: "152px", position: "fixed", top: isMobile ? "5rem":"7rem", right: "0px" }} alt="sso-image" />
                : null}
            <BackdropComponent showBackdrop={isVendorDetailsLoading} />
        </Box>
    )
}